import { useInfiniteQuery } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

export interface UseInfiniteMyResultsParams {
  limit?: number
  requestType?: 'image' | 'video'
  enabled?: boolean
}

export const useInfiniteMyResults = ({
  limit = 20,
  requestType,
  enabled = true,
}: UseInfiniteMyResultsParams) => {
  const result = useInfiniteQuery({
    queryKey: ['ai-studio', 'my-results', limit, requestType],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await aiStudioService.getMyResults({
        page: pageParam as number,
        limit,
        requestType,
      })
      return response
    },
    getNextPageParam: (lastPage: any) => {
      const currentPage = lastPage.page
      const totalPages = lastPage.totalPages
      return currentPage < totalPages ? currentPage + 1 : undefined
    },
    initialPageParam: 1,
    enabled,
    staleTime: 30000, // 30초간 캐시 유지
    refetchInterval: (query: any) => {
      // Check if there are any processing or pending jobs in the data
      const data = (query as any).state?.data
      const hasProcessingJobs = data?.pages?.some((page: any) =>
        page.items?.some((item: any) => 
          item.status === 'processing' || item.status === 'pending'
        )
      )
      // Poll every 5 seconds if there are processing jobs, otherwise no polling
      return hasProcessingJobs ? 5000 : false
    },
  } as any) // Type assertion to bypass complex generic type issues
  
  return result
}